// Opciones del filtro por "tipo" de paquete = ORIGEN / integración del pedido
// (campo `package.type` del documento). Usado en el modal "Filtrar y ordenar".
//
// Los `value` se envían tal cual al backend como `filters.type`. El controller
// los matchea case-insensitive y anclados (`^value$`, $options:'i') contra
// `package.type`, por lo que basta con el valor canónico tal como se persiste.
// Ref: microservice-packages/src/api/packages/dto/request-create-package.dto.ts
//      microservice-packages/src/api/packages/packages.controller.ts
//
// NOTA: esta lista NO tiene por qué replicar el enum `TypePackage` completo del
// backend (el filtro es string libre, tolera valores fuera del enum como
// "Falabella Directo"). Es solo el conjunto de orígenes que ofrecemos filtrar.
export const packageTypeFilterOptions = [
  { value: "MERCADOLIBRE", label: "MercadoLibre" },
  // El valor canónico es "Shopify" tal cual: es lo que persiste
  // `TypePackage.SHOPIFY` en microservice-packages. El backend matchea
  // case-insensitive, así que el casing acá no es crítico, pero se mantiene el
  // canónico para que el filtro siga funcionando si alguna vez se ancla exacto.
  { value: "Shopify", label: "Shopify" },
  { value: "Woocommerce", label: "WooCommerce" },
  { value: "Prestashop", label: "PrestaShop" },
  { value: "Jumpseller", label: "Jumpseller" },
  // `TypePackage.WIX` persiste "Wix" tal cual (mismo criterio que Shopify).
  { value: "Wix", label: "Wix" },
  { value: "Falabella", label: "Falabella" },
  { value: "Falabella Directo", label: "Falabella Directo" },
  { value: "Sendu", label: "Sendu" },
  { value: "OTS", label: "Manual" }, // value "OTS" se envía al backend; se muestra como "Manual"
  { value: "EXCEL", label: "Excel" },
  { value: "NOVAPET", label: "Novapet" },
];
